var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 44,
    viewBox: "0 0 55 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 14.954a5 5 0 0 0-5 5v13.55a5 5 0 0 0 5 5h2.647V44c3.704 0 6.895-2.252 8.345-5.495h14.185a5 5 0 0 0 5-5v-13.55a5 5 0 0 0-5-5H5z",
    fill: "#55A894"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.113 6.848a4 4 0 0 0-4 4v7.257a4 4 0 0 0 4 4h8.368c.745 2.05 2.755 3.52 5.118 3.52v-3.52h1.427a4 4 0 0 0 4-4v-7.257a4 4 0 0 0-4-4H31.113z",
    fill: "#55A894"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.823 11.03a5 5 0 0 0-5 5v13.55a5 5 0 0 0 5 5h2.647v5.495c3.704 0 6.895-2.252 8.345-5.495H34a5 5 0 0 0 5-5V16.03a5 5 0 0 0-5-5H8.823z",
    fill: "#F9F9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.013 22.884v-6.855a5 5 0 0 0-5-5H29.437v4.695a4 4 0 0 0 4 4h8.243c.546 1.482 1.78 2.652 3.333 3.16z",
    fill: "#55A894"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.087 1.544a4 4 0 0 0-4 4V12.8a4 4 0 0 0 4 4h8.368c.745 2.052 2.756 3.521 5.118 3.521v-3.52H51a4 4 0 0 0 4-4V5.543a4 4 0 0 0-4-4H36.087z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.b6b413de1319e46c2023c30a03c42c76.svg";
export { ForwardRef as ReactComponent };